import { useHookstate } from '@hookstate/core';
import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { globalBlockedState } from '../app-context';
import { welcomeMsg } from '../service/ApprentissageService';
import { getMyDashboard } from '../service/CdmGlobalService.js';
import { StructureContext } from '../structure-context';
import ScrbMain from './scrb/ScrbMain.jsx';
import { globalUserState, isGroupMembersWithoutHook } from '../user-context.js';

Dashboard.propTypes = {
    scrb: PropTypes.bool.isRequired
};

export default function Dashboard(props) {
    const blockedState = useHookstate(globalBlockedState);
    const structure = useContext(StructureContext);
    const user = useHookstate(globalUserState).get();
    const [myCdm, setMyCdm] = useState();

    useEffect(() => {
        let isSubscribed = true;
        const setInitialCallBack = (_mydata) => {
            if (isSubscribed && _mydata) {
                setMyCdm(_mydata);
                blockedState.set(false);
            }
        }
        if (structure.id) {
            getMyDashboard(structure.id, setInitialCallBack);
        }
        return () => (isSubscribed = false);
    },
        // eslint-disable-next-line
        [structure]);

    const informationsApprentissage = <>
        <div className="col-12 sm:col-12 md:col-12 lg:col-12">
            <div className="card">
                <h5>{I18n.get("Informations importantes")}</h5>
                {welcomeMsg(I18n.get("currentlanguage"))}
            </div>
        </div>
        {myCdm && (<>
            <div className="col-12 sm:col-12 md:col-12 lg:col-3" >
                <div className="card">
                    <h5 className="cdm-icon-header cdm-icon-app-header cdm-my-cdm-header" > {I18n.get("Apprentissage")}</h5>
                    <div className="grid">
                        <div className="col col-align-end"><div className="cdm-nb-caption">{myCdm.apprentissage && myCdm.apprentissage.nbApprentis ? myCdm.apprentissage.nbApprentis : 0}</div>
                            <div className="cdm-sub-caption">{I18n.get("Nombre d'apprentis")}</div></div>
                    </div>
                </div>
            </div>
            {myCdm.yde && myCdm.yde.certificats && (
                <div className="col-12 sm:col-12 md:col-12 lg:col-3" >
                    <div className="card" >
                        <h5 className="cdm-icon-header cdm-icon-yde-header cdm-my-cdm-header" > {I18n.get("Mes labels")}</h5>

                        <div className="grid" >
                            <div className="col col-align-end">
                                <div className="cdm-nb-caption">
                                    {myCdm.yde.certificats.length}
                                </div>
                                <div className="cdm-sub-caption">
                                    {I18n.get("Nombre de labels")}
                                </div>
                            </div>
                            <div className="col col-align-start">
                                {myCdm.yde.certificats.map((cert, idx) => {
                                    return (<div className={`cdm-icon-header cdm-icon-label-${cert.id}`} key={`certif_${idx}`}></div>)
                                })}
                            </div>
                        </div>
                    </div>
                </div>)}
        </>)}</>

    return (
        <>
            {props.scrb && (<ScrbMain />)}
            {isGroupMembersWithoutHook(['gerants', 'superviseurs_apprentissage'], structure, user) && informationsApprentissage}
        </>
    );
}